import { client } from './client';

// --- Reading Templates (nested under service) ---

export const getReadingTemplatesByService = async (serviceUid) => {
    const response = await client.get(`/v1/services/${serviceUid}/reading-templates`);
    return response.data?.items ?? response.data;
};

export const createReadingTemplate = async (serviceUid, data) => {
    const response = await client.post(`/v1/services/${serviceUid}/reading-templates`, data);
    return response.data;
};

export const updateReadingTemplate = async (uid, data) => {
    const response = await client.put(`/v1/reading-templates/${uid}`, data);
    return response.data;
};

export const deleteReadingTemplate = async (uid) => {
    const response = await client.delete(`/v1/reading-templates/${uid}`);
    return response.data;
};
